module.exports = __webpack_public_path__ + "img/checkmark.c288b73d.svg";